import PropTypes from "prop-types";
import React from "react";
import relatedProductsSidebarTemplate from "templates/modules/product/product_related_products_sidebar.jinja";
import Baustein from "web/react/components/baustein/baustein";
import { ProductImageCardPropType } from "web/types/product-image-card";

import "web/script/components/product-image-card";
import "web/script/components/tracked-link";


export const RelatedProductsSidebarPropType = PropTypes.shape({
    product_image_cards: PropTypes.arrayOf(ProductImageCardPropType).isRequired,
    view_more_url: PropTypes.string.isRequired,
});

function RelatedProductsSidebar({ className, relatedProductsSidebar }) {
    if (!relatedProductsSidebar) {
        return null;
    }

    return (
        <Baustein
            className={className}
            template={relatedProductsSidebarTemplate}
            args={{ related_products_sidebar: relatedProductsSidebar }}
        />
    );
}

RelatedProductsSidebar.propTypes = {
    className: PropTypes.string,
    relatedProductsSidebar: RelatedProductsSidebarPropType,
};

export default RelatedProductsSidebar;
